export const BRAND_NAME = "CampaignIQ";
export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/campaigniq-logo.png`;
